export enum ITipoUsuarioEnum {
  Administrador = 1,
  Contabilista = 2,
  Cliente = 3
}
export const tipoUsuario = [
  { id: ITipoUsuarioEnum.Administrador, display: 'Administrador' },
  { id: ITipoUsuarioEnum.Contabilista, display: 'Contabilista' },
  { id: ITipoUsuarioEnum.Cliente, display: 'Cliente' },
]